import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiButtonGroup: {
      styleOverrides: {
        grouped: {
          ':not(:last-of-type):hover': {
            borderRightColor: 'transparent',
          },
        },
      },
    },
  },
});

export default theme.components;
